import { env } from '@/config/env'

export const doLogout = () => {
  sessionStorage.clear()
  window.location.href = `${env.VITE_API_URL}/users/logout`
}
